const filterNamesMap: Record<string, string> = {
  healthcategories: 'Health Categories',
  costtypes: 'Cost Types',
  intendedaudiences: 'Intended Audiences',
  generalfeatures: 'General Features',
  clinicalfeatures: 'Clinical Features',
  accreditationtypes: 'Accreditation Types',
  platforms: 'Platforms',
  cardiology: 'Cardiology',
  healthyliving: 'Healthy Living',
  mentalhealth: 'Mental Health',
  respiratory: 'Respiratory',
  diabetes: 'Diabetes',
  neurological: 'Neurological',
};

export const getFilterName = (filterName: string) => {
  return filterNamesMap[filterName.trim().toLowerCase()] ?? filterName;
};

export const normalizeFilterName = (filterName: string) => {
  return filterName.trim().toLowerCase() ?? '';
};
